import { render, staticRenderFns } from "./dashboardadmin.vue?vue&type=template&id=1bd4a732&"
import script from "./dashboardadmin.vue?vue&type=script&lang=js&"
export * from "./dashboardadmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports